export default __webpack_public_path__ + "static/media/order-icon.5a06810e.svg";